
//'Zinc', 'Copper', 'Ferrous', 'Ferric'
export const IonEnum = {
    ZINC: "Zinc",
    COPPER: "Copper",
    FERROUS: "Ferrous"
  };